<template>
  <div>
    <v-tabs
      v-model="tab"
      fixed-tabs
      background-color="indigo"
      dark
      height="80px"
      show-arrows
      center-active
      slider-color="yellow"
    >
      <v-tab>
        Informasi
      </v-tab>         
      <!-- PENUNJUKAN LANGSUNG -->
      <template v-if="paket.metodePemilihan === 'TLA' && paket.statusPelaksanaan != 'N'">
        <!-- <v-tab v-if="undanganPeserta != null && (isPeserta || isUndangan)">Undangan Peserta</v-tab> -->
        <v-tab>Undangan Peserta</v-tab>
        <template v-if="isPeserta">
          <v-tab> Pengambilan Dokumen </v-tab>
          <v-tab v-if="showTabFeature(2)" @click="moveTab(2)"> Pemberian Penjelasan / Aanwizjing </v-tab>
          <v-tab v-if="showTabFeature(3)" @click="moveTab(3)"> Pemasukan Dokumen Penawaran </v-tab>
          <v-tab v-if="undanganNegosiasi != null" @click="moveTab(5)">Undangan Negosiasi</v-tab>
          <v-tab v-if="showTabFeature(7) && undanganNegosiasi != null" @click="moveTab(7)"> Berita Acara Klarifikasi & Negosiasi </v-tab>
          <v-tab v-if="showTabFeature(10) && undanganNegosiasi != null" @click="moveTab(10)"> Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
        </template>
      </template>
      <!-- PENGADAAN LANGSUNG -->
      <template v-else-if="paket.metodePemilihan === 'PLA' && paket.statusPelaksanaan != 'N'">
        <v-tab v-if="undanganPeserta != null" @click="moveTab(1)">Undangan Peserta</v-tab>
        <template v-if="isPeserta">
          <v-tab @click="moveTab(1)"> Pengambilan Dokumen </v-tab>
          <v-tab v-if="showTabFeature(2)" @click="moveTab(2)"> Pemberian Penjelasan / Aanwizjing </v-tab>
          <v-tab v-if="showTabFeature(3)" @click="moveTab(3)"> Pemasukan Dokumen Penawaran </v-tab>
          <v-tab v-if="showTabFeature(5)" @click="moveTab(5)"> Pengumuman Hasil Evaluasi </v-tab>
          <v-tab v-if="undanganNegosiasi != null && showTabFeature(6)" @click="moveTab(6)">Undangan Klarifikasi dan Negosiasi</v-tab>
          <v-tab v-if="undanganNegosiasi != null && showTabFeature(7)" @click="moveTab(7)">Berita Acara Klarifikasi dan Negosiasi</v-tab>
          <!-- <v-tab v-if="showTabFeature(8) && undanganNegosiasi != null"  @click="moveTab(8)"> Berita Acara Pengadaan Langsung </v-tab> -->
        </template>
      </template>
      <!-- TENDER -->
      <template v-else-if="paket.metodePemilihan === 'TEN' && paket.statusPelaksanaan != 'N' && isPeserta">
        <!-- Prakualifikasi -->
        <template v-if="paket.kualifikasi === 'P'">
          <v-tab v-if="includeTabProses.urut2" @click="moveTab(2)">Pendaftaran dan Pengambilan Dokumen Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut3" @click="moveTab(3)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut4" @click="moveTab(4)">Pemasukan Dokumen Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut7" @click="moveTab(7)">Undangan Pembuktian Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut10" @click="moveTab(10)">Pengumuman Hasil Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut11" @click="moveTab(11)">Masa Sanggah Kualifikasi</v-tab>
          <template v-if="lulusKualifikasiP">
              <v-tab v-if="includeTabProses.urut13" @click="moveTab(13)">Undangan Tender</v-tab>
              <v-tab v-if="includeTabProses.urut14" @click="moveTab(14)">Pendaftaran dan Pengambilan Dokumen Tender</v-tab>
              <v-tab v-if="includeTabProses.urut15" @click="moveTab(15)">Pemberian Penjelasan / Aanwizjing</v-tab>
              <v-tab v-if="includeTabProses.urut16" @click="moveTab(16)">Pemasukan Dokumen Penawaran Administrasi dan Teknis (File 1)</v-tab>
              <v-tab v-if="includeTabProses.urut19" @click="moveTab(19)">Undangan Pembuktian Dokumen Administrasi dan Teknis</v-tab>
              <v-tab v-if="includeTabProses.urut20" @click="moveTab(20)">Pengumuman Hasil Evaluasi Administrasi dan Teknis </v-tab>
              <v-tab v-if="includeTabProses.urut21 && lulusAdministrasi" @click="moveTab(21)">Pemasukan Dokumen Penawaran Harga (File 2) </v-tab>
              <v-tab v-if="includeTabProses.urut25" @click="moveTab(25)">Pengumuman Pemenang </v-tab>
              <v-tab v-if="includeTabProses.urut26" @click="moveTab(26)">Masa Sanggah </v-tab>
              <v-tab v-if="includeTabProses.urut27" @click="moveTab(27)">Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)</v-tab>
              <v-tab v-if="undanganNegosiasi != null && includeTabProses.urut29" @click="moveTab(29)">Undangan Klarifikasi Negosiasi Teknis dan Biaya</v-tab>
              <v-tab v-if="undanganNegosiasi != null && includeTabProses.urut31" @click="moveTab(31)">Berita Acara Klarifikasi Negosiasi Teknis dan Biaya</v-tab>
              <v-tab v-if="sppbj != null && includeTabProses.urut32" @click="moveTab(31)">Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
          </template>
        </template>
        <!-- Pascakualifikasi 1 File -->
        <template v-else-if="paket.kualifikasi === 'K'">
          <v-tab v-if="includeTabProses.urut2" @click="moveTab(2)">Pendaftaran dan Pengambilan Dokumen</v-tab>
          <v-tab v-if="includeTabProses.urut3" @click="moveTab(3)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut4" @click="moveTab(4)">Pemasukan Dokumen Penawaran</v-tab>
          <v-tab v-if="includeTabProses.urut7" @click="moveTab(7)">Undangan Pembuktian Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut10" @click="moveTab(10)">Pengumuman Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut11" @click="moveTab(11)">Masa Sanggah</v-tab>
          <v-tab v-if="undanganNegosiasi != null && includeTabProses.urut13" @click="moveTab(13)">Undangan Klarifikasi dan Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="undanganNegosiasi != null && includeTabProses.urut15" @click="moveTab(15)">Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="sppbj != null && includeTabProses.urut16" @click="moveTab(16)">Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
        </template>
        <!-- Pascakualifikasi 2 File -->
        <template v-else-if="paket.kualifikasi === 'K2'">
          <v-tab v-if="includeTabProses.urut2" @click="moveTab(2)">Pendaftaran Dan Pengambilan Dokumen</v-tab>
          <v-tab v-if="includeTabProses.urut3" @click="moveTab(3)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut4" @click="moveTab(4)">Pemasukan Dokumen Penawaran Administrasi Dan Teknis (file 1)</v-tab>
          <v-tab v-if="undanganPembuktianKualifikasi != null && includeTabProses.urut7" @click="moveTab(7)">Undangan Pembuktian Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut9" @click="moveTab(9)">Pengumuman Hasil Evaluasi Administrasi dan Teknis</v-tab>
          <v-tab v-if="tenK2LulusKualifikasiDanAdministrasi && includeTabProses.urut9" @click="moveTab(9)">Pemasukan Dokumen Penawaran Harga (file 2)</v-tab>
          <v-tab v-if="tenK2LulusKualifikasiDanAdministrasi && includeTabProses.urut10" @click="moveTab(10)">Pengumuman Pemenang</v-tab>
          <v-tab v-if="tenK2LulusKualifikasiDanAdministrasi && includeTabProses.urut14" @click="moveTab(14)">Masa Sanggah</v-tab>
          <v-tab v-if="tenK2LulusKualifikasiDanAdministrasi && includeTabProses.urut15" @click="moveTab(15)">Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)</v-tab>
          <v-tab v-if="undanganNegosiasi != null && includeTabProses.urut17" @click="moveTab(17)">Undangan Klarifikasi Negosiasi Teknis Dan Biaya</v-tab>
          <v-tab v-if="undanganNegosiasi != null && includeTabProses.urut19" @click="moveTab(19)">Berita Acara Klarifikasi Negosiasi Teknis Dan Biaya</v-tab>
          <v-tab v-if="sppbj != null && includeTabProses.urut20" @click="moveTab(20)">Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
        </template>
      </template>
      <!-- SELEKSI -->
      <template v-else-if="paket.metodePemilihan === 'SEL' && paket.statusPelaksanaan != 'N' && isPeserta">
        <!-- Prakualifikasi -->
        <template v-if="paket.kualifikasi === 'P'">
          <v-tab v-if="includeTabProses.urut2" @click="moveTab(2)">Pendaftaran dan Pengambilan Dokumen Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut3" @click="moveTab(3)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut4" @click="moveTab(4)">Pemasukan Dokumen Prakualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut7" @click="moveTab(7)">Undangan Pembuktian Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut10" @click="moveTab(10)">Pengumuman Hasil Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut11" @click="moveTab(11)">Masa Sanggah Kualifikasi</v-tab>
          <template v-if="lulusKualifikasiP">
              <v-tab v-if="includeTabProses.urut13" @click="moveTab(13)">Undangan Tender</v-tab>
              <v-tab v-if="includeTabProses.urut14" @click="moveTab(14)">Pendaftaran dan Pengambilan Dokumen Tender</v-tab>
              <v-tab v-if="includeTabProses.urut15" @click="moveTab(15)">Pemberian Penjelasan / Aanwizjing</v-tab>
              <v-tab v-if="includeTabProses.urut16" @click="moveTab(16)">Pemasukan Dokumen Penawaran Administrasi dan Teknis (File 1)</v-tab>
              <v-tab v-if="includeTabProses.urut19" @click="moveTab(19)">Undangan Pembuktian Dokumen Administrasi dan Teknis</v-tab>
              <v-tab v-if="includeTabProses.urut20" @click="moveTab(20)">Pengumuman Hasil Evaluasi Administrasi dan Teknis </v-tab>
              <v-tab v-if="includeTabProses.urut21 && lulusAdministrasi" @click="moveTab(21)">Pemasukan Dokumen Penawaran Biaya (File 2) </v-tab>
              <v-tab v-if="includeTabProses.urut25" @click="moveTab(25)">Pengumuman Pemenang </v-tab>
              <v-tab v-if="includeTabProses.urut26" @click="moveTab(26)">Masa Sanggah </v-tab>
              <!-- <v-tab v-if="includeTabProses.urut27" @click="moveTab(27)">Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)</v-tab> -->
              <v-tab v-if="undanganNegosiasi != null && includeTabProses.urut29" @click="moveTab(29)">Undangan Klarifikasi Negosiasi Teknis dan Biaya</v-tab>
              <v-tab v-if="undanganNegosiasi != null && includeTabProses.urut31" @click="moveTab(31)">Berita Acara Klarifikasi Negosiasi Teknis dan Biaya</v-tab>
              <v-tab v-if="sppbj != null && includeTabProses.urut32" @click="moveTab(31)">Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
          </template>
        </template>
        <!-- Pascakualifikasi -->
        <template v-else-if="paket.kualifikasi === 'K'">
          <v-tab v-if="includeTabProses.urut2" @click="moveTab(2)">Pendaftaran dan Pengambilan Dokumen</v-tab>
          <v-tab v-if="includeTabProses.urut3" @click="moveTab(3)">Pemberian Penjelasan / Aanwizjing</v-tab>
          <v-tab v-if="includeTabProses.urut4" @click="moveTab(4)">Pemasukan Dokumen Penawaran</v-tab>
          <v-tab v-if="includeTabProses.urut7" @click="moveTab(7)">Undangan Pembuktian Kualifikasi</v-tab>
          <v-tab v-if="includeTabProses.urut10" @click="moveTab(10)">Pengumuman Pemenang</v-tab>
          <v-tab v-if="includeTabProses.urut11" @click="moveTab(11)">Masa Sanggah</v-tab>
          <v-tab v-if="undanganNegosiasi != null && includeTabProses.urut13" @click="moveTab(13)">Undangan Klarifikasi dan Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="undanganNegosiasi != null && includeTabProses.urut15" @click="moveTab(15)">Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya</v-tab>
          <v-tab v-if="sppbj != null && includeTabProses.urut16" @click="moveTab(16)">Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)</v-tab>
        </template>
      </template>
    </v-tabs>

    <!-- ==================== tab items ===================================================================== -->
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <LockPage v-if="kunciInformasi"/>
        <PreviewLelangVendor :vendorEvaluasi="hasilEvaluasi"></PreviewLelangVendor>
      </v-tab-item >      
      <!-- PENUNJUKAN LANGSUNG -->
      <template v-if="paket.metodePemilihan === 'TLA' && paket.statusPelaksanaan != 'N'">
        <!-- <v-tab-item v-if="undanganPeserta != null && (isPeserta || isUndangan)">   -->
        <v-tab-item>  
        <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
          <PengambilanUndangan :undangan="undanganPeserta" />
          1. Undangan Peserta 
        </v-tab-item>
        <template v-if="isPeserta">
          <v-tab-item> <JadwalView :jadwal="paramJadwal"/>  
             <DownloadDokumenPL /> 
             2. Pengambilan Dokumen
          </v-tab-item>
          <v-tab-item v-if="showTabFeature(5)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
            <ChatMessage tahap="PP" :vendor="true" :urut="5" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(5)" /> 
            3. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="showTabFeature(6)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
            <PemasukanDokumen penawaran :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(6)" /> 
            4. Pemasukan Dokumen Penawaran
          </v-tab-item>
          <v-tab-item v-if="undanganNegosiasi != null && showTabFeature(5)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
            <PengambilanUndangan :undangan="undanganNegosiasi" /> 
            5. Undangan Negosiasi
          </v-tab-item>
          <v-tab-item v-if="undanganNegosiasi != null && showTabFeature(8)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
            <VendorPengambilanBaKlarifikasiNegosiasi :vendor="true" :urut="8" /> 
            6. Berita Acara Klarifikasi & Negosiasi
          </v-tab-item>
          <v-tab-item v-if="undanganNegosiasi != null && showTabFeature(10)"> <LockPage v-if="kunciProses"/><JadwalView :jadwal="paramJadwal"/>  
            <VendorPengambilanSppbj :vendor="true" :urut="10" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(10)"/> 
            7. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
          </v-tab-item>
        </template>
        
      </template>
      <!-- PENGADAAN LANGSUNG -->
      <template v-else-if="paket.metodePemilihan === 'PLA' && paket.statusPelaksanaan != 'N'">
        <v-tab-item v-if="undanganPeserta != null"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
          <PengambilanUndangan :undangan="undanganPeserta"/> 
        </v-tab-item>
        <template v-if="isPeserta">
          <v-tab-item> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
            <DownloadDokumenPL /> 
          </v-tab-item>
          <v-tab-item v-if="showTabFeature(2)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
            <ChatMessage tahap="PP" :vendor="true" :urut="2" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(2)" /> 
          </v-tab-item>
          <v-tab-item v-if="showTabFeature(3)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
            <PemasukanDokumen penawaran  :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" /> 
          </v-tab-item>
          <v-tab-item v-if="showTabFeature(5)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
            <FilePengumuman :vendor="true" :urut="5"/>
            <!-- todo -->
            <Evaluasi 
              v-if="!kunciProses"
              kualifikasi
              administrasi
              biaya
              :passingGrade="showPSG()"
              teknis
              nilaiTeknis
              nilaiPenawaran
              nilaiBiaya
              totalNilai
              pemenang
              :vendor="true"
              readonly /> 
          </v-tab-item>
          <v-tab-item v-if="undanganNegosiasi != null && showTabFeature(6)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
            <PengambilanUndangan :undangan="undanganNegosiasi" /> 
          </v-tab-item>
          <v-tab-item v-if="undanganNegosiasi != null && showTabFeature(7)"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>  
            <VendorPengambilanBaKlarifikasiNegosiasi :vendor="true" :urut="7" /> 
          </v-tab-item>
        </template>
        
      </template>
      <!-- TENDER -->
      <template v-else-if="paket.metodePemilihan === 'TEN' && paket.statusPelaksanaan != 'N' && isPeserta">
        <!-- Prakualifikasi -->
        <template v-if="paket.kualifikasi === 'P'">
          <v-tab-item v-if="includeTabProses.urut2"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
              <DownloadDokumenPL />
              2. Pendaftaran dan Pengambilan Dokumen Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut3"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
              <ChatMessage tahap="PP0" :vendor="true" :urut="3"  :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" /> 
              3. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut4"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PemasukanDokumen kualifikasi :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(4)" /> 
              4. Pemasukan Dokumen Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut7"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PengambilanUndangan :undangan="undanganPembuktianKualifikasi" />
              7. Undangan Pembuktian Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut10"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <FilePengumuman :vendor="true" :urut="10"/>
              <Evaluasi v-if="!hidePengumuman" kualifikasi readonly />
              10. Pengumuman Hasil Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut11"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <VendorMasaSanggah :tipe="'P'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(11)" /> 
              11. Masa Sanggah Kualifikasi
          </v-tab-item>
          <!-- lulus kualifikasi -->
          <template v-if="lulusKualifikasiP">
              <v-tab-item v-if="includeTabProses.urut13"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <PengambilanUndangan :undangan="undanganLulusKualifikasi" />
                  13. Undangan Tender
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut14"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <DownloadDokumenTenderP />
                  14. Pendaftaran dan Pengambilan Dokumen Tender
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut15"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <ChatMessage tahap="PP1" :vendor="true" :urut="15"  :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" /> 
                  15. Pemberian Penjelasan / Aanwizjing
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut16"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <PemasukanDokumen  administrasi teknis :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(16)" />
                  16. Pemasukan Dokumen Penawaran Administrasi dan Teknis (File 1)
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut19"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <PengambilanUndangan :undangan="undanganPembuktianAdministrasiTeknis" />
                  19. Undangan Pembuktian Dokumen Administrasi dan Teknis
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut20"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <FilePengumuman :vendor="true" :urut="20"/>
                  <Evaluasi v-if="!hidePengumuman"  administrasi nilaiTeknis readonly /> 
                  20. Pengumuman Hasil Evaluasi Administrasi dan Teknis 
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut21 && lulusAdministrasi"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <PemasukanDokumen  harga :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(21)" />
                  21. Pemasukan Dokumen Penawaran Harga (File 2) 
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut25"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <FilePengumuman :vendor="true" :urut="25"/>
                  <Evaluasi v-if="!hidePengumuman" administrasi nilaiTeknis nilaiPenawaran nilaiBiaya totalNilai pemenang readonly/> 
                  25. Pengumuman Pemenang 
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut26"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <VendorMasaSanggah :tipe="'B'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(26)" /> 
                  26. Masa Sanggah 
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut27"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <VendorMasaSanggah :tipe="'BD'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(27)" /> 
                  27. Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)
              </v-tab-item>
              <v-tab-item v-if="undanganNegosiasi != null && includeTabProses.urut29"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <PengambilanUndangan :undangan="undanganNegosiasi" /> 
                  29. Undangan Klarifikasi dan Negosiasi Teknis dan Biaya
              </v-tab-item>
              <v-tab-item v-if="undanganNegosiasi != null && includeTabProses.urut31"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <VendorPengambilanBaKlarifikasiNegosiasi :vendor="true" :urut="31" /> 
                  14. Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya
              </v-tab-item>
              <v-tab-item v-if="sppbj != null && includeTabProses.urut31"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <VendorPengambilanSppbj :vendor="true" :urut="31" />  
                  31. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
              </v-tab-item>
          </template>
        </template>
        <!-- Pascakualifikasi 1 File -->
        <template v-else-if="paket.kualifikasi === 'K'">
          <v-tab-item v-if="includeTabProses.urut2"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <DownloadDokumenPL />
              2. Pendaftaran dan Pengambilan Dokumen
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut3"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <ChatMessage tahap="PP" :vendor="true" :urut="3" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" />
              3. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut4"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PemasukanDokumen kualifikasi administrasi teknis harga :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(4)" />
              4. Pemasukan Dokumen Penawaran
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut7"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PengambilanUndangan :undangan="undanganPembuktianKualifikasi" />
              7. Undangan Pembuktian Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut10"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi v-if="!hidePengumuman" kualifikasi administrasi nilaiTeknis nilaiPenawaran nilaiBiaya totalNilai pemenang readonly />  
              10. Pengumuman Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut11"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <VendorMasaSanggah :tipe="'B'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(26)" />
              11. Masa Sanggah
          </v-tab-item>
          <v-tab-item v-if="undanganNegosiasi != null && includeTabProses.urut13"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PengambilanUndangan :undangan="undanganNegosiasi" />
              13. Undangan Klarifikasi dan Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="undanganNegosiasi != null && includeTabProses.urut15"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <VendorPengambilanBaKlarifikasiNegosiasi :vendor="true" :urut="15" /> 
              15. Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="sppbj != null && includeTabProses.urut16"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <VendorPengambilanSppbj :vendor="true" :urut="16" /> 
              16. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
          </v-tab-item>
        </template>
        <!-- Pascakualifikasi 2 File -->
        <template v-else-if="paket.kualifikasi === 'K2'">
          <v-tab-item v-if="includeTabProses.urut2"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <DownloadDokumenPL />
              2. Pendaftaran Dan Pengambilan Dokumen
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut3"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <ChatMessage tahap="PP" :vendor="true" :urut="3" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" />
              3. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut4"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
              <PemasukanDokumen kualifikasi administrasi teknis :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(4)" />
              4. Pemasukan Dokumen Penawaran Administrasi Dan Teknis (file 1)
          </v-tab-item>
          <v-tab-item v-if="undanganPembuktianKualifikasi != null && includeTabProses.urut7"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PengambilanUndangan :undangan="undanganPembuktianKualifikasi" /> 
              7. Undangan Pembuktian Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut8"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <FilePengumuman :vendor="true" :urut="8"/>
              <Evaluasi v-if="!hidePengumuman" kualifikasi administrasi bobotTeknis teknis nilaiTeknis readonly /> 
              8. Pengumuman Hasil Evaluasi Administrasi dan Teknis
          </v-tab-item>
          <v-tab-item v-if="tenK2LulusKualifikasiDanAdministrasi && includeTabProses.urut9"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
              <PemasukanDokumen harga :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(9)" />
              9. Pemasukan Dokumen Penawaran Harga (file 2)
          </v-tab-item>
          <v-tab-item v-if="tenK2LulusKualifikasiDanAdministrasi && includeTabProses.urut13"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
              <FilePengumuman :vendor="true" :urut="13"/>
              <Evaluasi administrasi nilaiTeknis nilaiPenawaran nilaiBiaya totalNilai pemenang readonly/>
              13. Pengumuman Pemenang
          </v-tab-item>
          <v-tab-item v-if="tenK2LulusKualifikasiDanAdministrasi && includeTabProses.urut14"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <VendorMasaSanggah :tipe="'B'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(14)" /> 
              14. Masa Sanggah
          </v-tab-item>
          <v-tab-item v-if="tenK2LulusKualifikasiDanAdministrasi && includeTabProses.urut15"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <VendorMasaSanggah :tipe="'BD'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(15)" /> 
              15. Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)
          </v-tab-item>
          <v-tab-item v-if="undanganNegosiasi != null && includeTabProses.urut17"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
              <PengambilanUndangan :undangan="undanganNegosiasi" />
              17. Undangan Klarifikasi Negosiasi Teknis Dan Biaya
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut18 && undanganNegosiasi != null"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
              <VendorPengambilanBaKlarifikasiNegosiasi :vendor="true" :urut="18" />
              18. Berita Acara Klarifikasi Negosiasi Teknis Dan Biaya
          </v-tab-item>
          <v-tab-item v-if="sppbj != null && includeTabProses.urut20"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <VendorPengambilanSppbj :vendor="true" :urut="20" /> 
              20. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
          </v-tab-item>
        </template>
      </template>
      <!-- SELEKSI -->
      <template v-else-if="paket.metodePemilihan === 'SEL' && paket.statusPelaksanaan != 'N' && isPeserta">
        <!-- Prakualifikasi -->
        <template v-if="paket.kualifikasi === 'P'">
          <v-tab-item v-if="includeTabProses.urut2"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
              <DownloadDokumenPL />
              2. Pendaftaran dan Pengambilan Dokumen Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut3"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
              <ChatMessage tahap="PP0" :vendor="true" :urut="3"  :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" /> 
              3. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut4"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PemasukanDokumen kualifikasi :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(4)" /> 
              4. Pemasukan Dokumen Prakualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut7"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PengambilanUndangan :undangan="undanganPembuktianKualifikasi" />
              7. Undangan Pembuktian Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut10"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <FilePengumuman :vendor="true" :urut="10"/>
              <Evaluasi v-if="!hidePengumuman" kualifikasi readonly />
              10. Pengumuman Hasil Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut11"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <VendorMasaSanggah :tipe="'P'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(11)" /> 
              11. Masa Sanggah Kualifikasi
          </v-tab-item>
          <!-- lulus kualifikasi -->
          <template v-if="lulusKualifikasiP">
              <v-tab-item v-if="includeTabProses.urut13"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <PengambilanUndangan :undangan="undanganLulusKualifikasi" />
                  13. Undangan Tender
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut14"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <DownloadDokumenTenderP />
                  14. Pendaftaran dan Pengambilan Dokumen Tender
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut15"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <ChatMessage tahap="PP1" :vendor="true" :urut="15"  :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" /> 
                  15. Pemberian Penjelasan / Aanwizjing
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut16"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <PemasukanDokumen  administrasi teknis :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(16)" />
                  16. Pemasukan Dokumen Penawaran Administrasi dan Teknis (File 1)
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut19"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <PengambilanUndangan :undangan="undanganPembuktianAdministrasiTeknis" />
                  19. Undangan Pembuktian Dokumen Administrasi dan Teknis
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut20"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <FilePengumuman :vendor="true" :urut="20"/>
                  <Evaluasi v-if="!hidePengumuman"  administrasi nilaiTeknis readonly /> 
                  20. Pengumuman Hasil Evaluasi Administrasi dan Teknis 
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut21 && lulusAdministrasi"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <PemasukanDokumen  harga :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(21)" />
                  21. Pemasukan Dokumen Penawaran Biaya (File 2) 
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut25"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <FilePengumuman :vendor="true" :urut="25"/>
                  <Evaluasi v-if="!hidePengumuman" administrasi nilaiTeknis nilaiPenawaran nilaiBiaya totalNilai pemenang readonly/> 
                  25. Pengumuman Pemenang 
              </v-tab-item>
              <v-tab-item v-if="includeTabProses.urut26"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <VendorMasaSanggah :tipe="'B'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(26)" /> 
                  26. Masa Sanggah 
              </v-tab-item>
              <!-- <v-tab-item v-if="includeTabProses.urut27"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <VendorMasaSanggah :tipe="'BD'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(27)" /> 
                  27. Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)
              </v-tab-item> -->
              <v-tab-item v-if="undanganNegosiasi != null && includeTabProses.urut29"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/> 
                  <PengambilanUndangan :undangan="undanganNegosiasi" /> 
                  29. Undangan Klarifikasi dan Negosiasi Teknis dan Biaya
              </v-tab-item>
              <v-tab-item v-if="undanganNegosiasi != null && includeTabProses.urut31"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <VendorPengambilanBaKlarifikasiNegosiasi :vendor="true" :urut="31" /> 
                  14. Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya
              </v-tab-item>
              <v-tab-item v-if="sppbj != null && includeTabProses.urut31"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
                  <VendorPengambilanSppbj :vendor="true" :urut="31" />  
                  31. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
              </v-tab-item>
          </template>
        </template>
        <!-- Pascakualifikasi -->
        <template v-else-if="paket.kualifikasi === 'K'">
          <v-tab-item v-if="includeTabProses.urut2"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <DownloadDokumenPL />
              2. Pendaftaran dan Pengambilan Dokumen
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut3"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <ChatMessage tahap="PP" :vendor="true" :urut="3" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(3)" />
              3. Pemberian Penjelasan / Aanwizjing
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut4"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PemasukanDokumen kualifikasi administrasi teknis harga :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(4)" />
              4. Pemasukan Dokumen Penawaran
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut7"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PengambilanUndangan :undangan="undanganPembuktianKualifikasi" />
              7. Undangan Pembuktian Kualifikasi
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut10"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <Evaluasi v-if="!hidePengumuman" kualifikasi administrasi nilaiTeknis nilaiPenawaran nilaiBiaya totalNilai pemenang readonly />  
              10. Pengumuman Pemenang
          </v-tab-item>
          <v-tab-item v-if="includeTabProses.urut11"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <VendorMasaSanggah :tipe="'B'" :readonly="paket.statusPelaksanaan !== 'A' || readonlyTabFeature(26)" />
              11. Masa Sanggah
          </v-tab-item>
          <v-tab-item v-if="undanganNegosiasi != null && includeTabProses.urut13"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <PengambilanUndangan :undangan="undanganNegosiasi" />
              13. Undangan Klarifikasi dan Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="undanganNegosiasi != null && includeTabProses.urut15"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <VendorPengambilanBaKlarifikasiNegosiasi :vendor="true" :urut="15" /> 
              15. Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya
          </v-tab-item>
          <v-tab-item v-if="sppbj != null && includeTabProses.urut16"> <LockPage v-if="kunciProses"/> <JadwalView :jadwal="paramJadwal"/>
              <VendorPengambilanSppbj :vendor="true" :urut="16" /> 
              16. Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)
          </v-tab-item>
        </template>
      </template>
    </v-tabs-items>      
  </div>
</template>

<script>
const apiUrl = process.env.VUE_APP_ROOT_API
import axios from "axios";
import PreviewLelangVendor from './PreviewLelangVendor'
import DownloadDokumenPL from './PengadaanLangsung/DownloadDokumenPL'
//--
//import UploadPenawaranPL from './PengadaanLangsung/UploadPenawaranPL'
//import PengumumanEvaluasiPL from './PengadaanLangsung/PengumumanEvaluasiPL'
// import BeritaAcaraPL from './PengadaanLangsung/BeritaAcaraPL'
//--
import ChatMessage from './ChatMessage'
//--
//import UploadPenawaranK1 from "./PascaKualifikasi/VendorUploadPenawaranK1"
//import UploadPenawaranK2 from "./PascaKualifikasi/VendorUploadPenawaranK2"
//import UploadHargaK2 from "./PascaKualifikasi/VendorUploadHargaK2"
//import PengumumanEvaluasiK2 from "./PascaKualifikasi/VendorPengumumanEvaluasiK2"
//import PengumumanPemenangK from "./PascaKualifikasi/VendorPengumumanPemenang"
//import BeritaAcaraK from "./PascaKualifikasi/BeritaAcara"

// Prakualifikasi
//import UploadKualifikasiP from "./Prakualifikasi/VendorUploadKualifikasi"
//import PengumumanHasilKualifikasiP from "./Prakualifikasi/VendorPengumumanHasilKualifikasi"
//--
import DownloadDokumenTenderP from "./Prakualifikasi/VendorDownloadDokumenPemilihan"
//--
//import UploadPenawaranP from "./Prakualifikasi/VendorUploadPenawaran"
//import PengumumanHasilAdministrasiTeknisP from "./Prakualifikasi/VendorPengumumanHasilAdministrasiTeknis"
//import PengumumanPemenangP from "./Prakualifikasi/VendorPengumumanPemenang"
//import BeritaAcaraP from "./Prakualifikasi/BeritaAcara"

// Penunjukan Langsung
//import UploadKualifikasiTL from "./PenunjukanLangsung/VendorUploadKualifikasi"
//import UploadPenawaranTL from "./PenunjukanLangsung/VendorUploadPenawaran"
//import PengumumanPenyediaTL from "./PenunjukanLangsung/VendorPengumumanPenyedia"
//import BeritaAcaraTL from "./PenunjukanLangsung/BeritaAcara"
// import BeritaAcaraKlarifikasiNegosiasiPL from "./PengadaanLangsung/BeritaAcaraKlarifikasiNegosiasiPL"
//--
import VendorPengambilanBaKlarifikasiNegosiasi from "./VendorPengambilanBaKlarifikasiNegosiasi"
import VendorMasaSanggah from "./VendorMasaSanggah"
import VendorPengambilanSppbj from "./VendorPengambilanSppbj"
import FilePengumuman from "./FilePengumuman"

import PemasukanDokumen from "./VendorPemasukanDokumen"
import Evaluasi from "./Evaluasi"
import PengambilanUndangan from "./VendorPengambilanUndangan" 
import LockPage from "./LockPage"
import JadwalView from "./JadwalView"
import { format, parseISO } from 'date-fns'
//import getDate from 'date-fns/fp/getDate/index.js';


export default {
  components: { LockPage,  JadwalView,
    PreviewLelangVendor, 
    DownloadDokumenPL, 
    //--
    //UploadPenawaranPL, 
    //PengumumanEvaluasiPL,
    //BeritaAcaraPL,
    //--

    ChatMessage,
    PemasukanDokumen,
    Evaluasi,
    //--
    // Prakualifikasi
    //UploadKualifikasiP,
    //PengumumanHasilKualifikasiP,
    //--
    DownloadDokumenTenderP,
    //--
    //UploadPenawaranP,
    //PengumumanHasilAdministrasiTeknisP,
    //PengumumanPemenangP,
    //BeritaAcaraP,

    // Pascakualifikasi
    //UploadPenawaranK1,
    //UploadPenawaranK2, 
    //UploadHargaK2, 
    //PengumumanEvaluasiK2,
    //PengumumanPemenangK, 
    //BeritaAcaraK, 

    // Penunjukan Langsung
    //UploadKualifikasiTL,
    //UploadPenawaranTL,
    //PengumumanPenyediaTL,
    //BeritaAcaraTL,
    //--
    PengambilanUndangan,
    //--
    // BeritaAcaraKlarifikasiNegosiasiPL
    //--
    VendorPengambilanBaKlarifikasiNegosiasi,
    VendorMasaSanggah,
    VendorPengambilanSppbj,
    FilePengumuman
  },
  computed: {
    paket: function() {
      return this.$store.getters['lelang/paket']
    },
    jadwal: function() {
      return this.$store.getters['lelang/jadwal']
    },
    isPeserta: function() {
      return this.$store.getters['lelang/peserta']
    },
    userId: function() {
      return this.$store.getters['userInfo'].userId;
    }
  },

  watch: {
    paket() {
      this.getDataEvaluasi();
      this.getDataUndangan();
    },
  },

  data() {
    return {
      tab: null,
      serverTime: null,
      checkJadwal: false,
      hasilEvaluasi: null,
      lulusKualifikasiP: false,
      lulusAdministrasiKualifikasiK2: false,
      lulusTeknisK2: false,
      lulusHargaK2: false,
      pemenangK2: false,
      undanganPeserta: false,
      undanganPembuktianKualifikasi: false,
      undanganPembuktianAdministrasiTeknis:false,
      undanganLulusKualifikasi: false,
      undanganNegosiasi: false,
      sppbj: false,
      paramJadwal: "",
      kunciProses: false,
      kunciInformasi: false,
      tenK2LulusKualifikasiDanAdministrasi: false,
      lulusAdministrasi: false,
      hidePengumuman:false,
      includeTabProses:{
          urut1: false,
          urut2: false,
          urut3: false,
          urut4: false,
          urut5: false,
          urut6: false,
          urut7: false,
          urut8: false,
          urut9: false,
          urut10: false,
          urut11: false,
          urut12: false,
          urut13: false,
          urut14: false,
          urut15: false,
          urut16: false,
          urut17: false,
          urut18: false,
          urut19: false,
          urut20: false,
          urut21: false,
          urut22: false,
          urut23: false,
          urut24: false,
          urut25: false,
          urut26: false,
          urut27: false,
          urut28: false,
          urut29: false,
          urut30: false,
          urut31: false,
          urut32: false,
          urut33: false,
          urut34: false,
          urut35: false,
          urut36: false,
          urut37: false,
          urut38: false,
          urut39: false,
          urut40: false
      }
    }
  },

  async mounted() {
    

    /*
    const vendorId = this.$store.getters["ven/venId"];

    await axios.get(`${apiUrl}/api/rup/lelang/evaluasipl/${this.paket.id}`)
    .then( (response) => {
      const listEvaluasi = response.data;
      //console.log("List Evaluasi Paket: ", this.paket.id, listEvaluasi);
      const check = listEvaluasi.find(element => element.vendorId == vendorId);
      if (check) {
        console.log("Check tahap lulus evaluasi vendor: ", vendorId);
        this.lulusKualifikasiP = check.hasilKualifikasi && check.lulusKualifikasi;
        this.lulusAdministrasiKualifikasiK2 = check.hasilAdministrasi && check.hasilKualifikasi;
        this.lulusTeknisK2 = check.lulusTeknis;
        this.lulusHargaK2 = check.lulusHarga;
        this.pemenangK2 = check.urutan == 1;
      }

      //console.log("VendorId: ", vendorId, "AdministrasiKualifikasi: ", this.lulusAdministrasiKualifikasiK2, "Teknis: ", this.lulusTeknisK2, "Harga: ", this.lulusHargaK2);
    })
    .catch( (error) => {
      console.error(error);
    })
    */
    if(this.paket.statusPelaksanaan == 'S') {
        this.kunciInformasi = true;
    }
    this.getDataEvaluasi();
    this.getDataUndangan();
    this.getDataSppbj();
    this.forceIncludeTabProses();
  },

  methods: {
    async getDataEvaluasi() {
      const vendorId = this.$store.getters["ven/venId"];
      this.hasilEvaluasi = null;
      this.lulusKualifikasiP = false;
      this.lulusAdministrasiKualifikasiK2 = false;
      this.lulusTeknisK2 = false;
      this.lulusHargaK2 = false;
      this.pemenangK2 = false;

      if (!this.isPeserta) return;

      await axios.get(`${apiUrl}/api/lelang/evaluasi/${this.paket.id}/${vendorId}`)
      .then( (response) => {
        const check = response.data;
        if (check) {
          this.hasilEvaluasi = check;
          this.lulusKualifikasiP = check.hasilKualifikasi && check.lulusKualifikasi;
          this.lulusAdministrasiKualifikasiK2 = check.hasilAdministrasi && check.hasilKualifikasi;
          this.lulusTeknisK2 = check.lulusTeknis;
          this.lulusHargaK2 = check.lulusHarga;
          this.pemenangK2 = check.urutan == 1;
          this.lulusAdministrasi = check.hasilAdministrasi;
          console.log('lulusAdministrasi',this.lulusAdministrasi)
          if(this.paket.metodePemilihan === 'TEN') {
              if(this.paket.kualifikasi === 'K2') {
                this.tenK2LulusKualifikasiDanAdministrasi = check.lulusKualifikasi && check.hasilAdministrasi;
              }
          }
        }
      }).catch( (error) => {
        console.error(error);
      });
    },
    showPSG() {
      return this.paket.metodeEvaluasi == 'RENPSG' || this.paket.metodeEvaluasi == 'NILPSG' ? true : false;
    },

    async getDataUndangan() {
      const vendorId = this.$store.getters["ven/venId"];

      this.undanganPeserta = null;
      this.undanganPembuktianKualifikasi = null;
      this.undanganPembuktianAdministrasiTeknis = null;
      this.undanganLulusKualifikasi = null;
      this.undanganNegosiasi = null;

      await axios.get(`${apiUrl}/api/lelang/undangan/vendor/${this.paket.id}/${vendorId}`)
      .then( (response) => {
        const listUndangan = response.data;
        listUndangan.forEach(element => {
          if (element.tipe === 'P') this.undanganPeserta = element;
          if (element.tipe === 'B') this.undanganPembuktianKualifikasi = element;
          if (element.tipe === 'B2') this.undanganPembuktianAdministrasiTeknis = element;
          if (element.tipe === 'L') this.undanganLulusKualifikasi = element;
          if (element.tipe === 'N') this.undanganNegosiasi = element;
        });
      }).catch( (error) => {
        console.error(error);
      });
    },
    async getDataSppbj() {
      const vendorId = this.$store.getters["ven/venId"];
        await axios.get(`${apiUrl}/api/lelang/sppbj/vendor/${this.paket.id}/${vendorId}`)
        .then( (response) => {
            this.sppbj = response.data[0];
        }).catch( (error) => {
            console.error(error);
        });
    },
    showTabFeature(urut) {
      return urut > 0;
      /*
      const check = this.jadwal.find(element => element.include && element.urut == urut);
      if (check == null) return false;
      if (!this.checkJadwal) return true;
      const bShow = check && Date.parse(this.serverTime) >= Date.parse(check.mulai);
      //console.log("Show Tab Feature: ", urut, bShow);
      return bShow;
      */
    },
    
    readonlyTabFeature(urut) {
      if (!this.checkJadwal) return false;
      const check = this.jadwal.find(element => element.include && element.urut == urut);
      const bReadOnly = check && Date.parse(check.selesai) < Date.parse(this.serverTime); 
      //console.log("Readonly Tab Feature: ", urut, bReadOnly);
      return bReadOnly;
    },
    async moveTab(urut) {
        await axios.get(`${apiUrl}/api/time`)
        .then( (response) => {
          this.serverTime = response.data.time;
        })
        .catch( (error) => {
          console.error(error);
        });
        let objJadwal = this.jadwal.find(el => el.urut === urut); 
        this.paramJadwal = this.getDateFormattedDatefnsMinute(objJadwal.mulai) +" - "+ this.getDateFormattedDatefnsMinute(objJadwal.selesai);
        
        const nowDate = new Date(this.getDateFormattedDatefnsMinute(this.serverTime));
        const startDateTime = new Date(this.getDateFormattedDatefnsMinute(objJadwal.mulai));
        const endDateTime = new Date(this.getDateFormattedDatefnsMinute(objJadwal.selesai));
        if(this.paket.statusPelaksanaan !== 'A') {
            this.kunciProses = true;
        }else if(nowDate > startDateTime && nowDate < endDateTime) {
            this.kunciProses = false;
        }else {
            this.kunciProses = true;
        }

        if(nowDate < startDateTime) {
          this.hidePengumuman= true;
        }
    },
    getDateFormattedDatefnsMinute: function(date) {
        return date ? format(parseISO(date), "dd MMM yyyy HH:mm") : '';
    },
    forceIncludeTabProses() {
        this.jadwal.forEach(element => {
            this.includeTabProses['urut'+element.urut] = element.include;
        });
    }
  }
}
</script>

<style scoped>
.container{
  max-width: 100vw;
  padding:0px;
}
</style>